
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-dark/95 backdrop-blur-md shadow-lg shadow-dark/50 border-b border-dark-border' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="cursor-pointer">
            {isHomePage ? (
              <h1 className="m-0 p-0">
                <img
                  src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png"
                  alt="NeuroAgents Global AI - Automação de Atendimento por IA"
                  className="h-10 w-auto"
                />
              </h1>
            ) : (
              <img
                src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png"
                alt="NeuroAgents Global AI"
                className="h-10 w-auto"
              />
            )}
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('solucao')}
              className="text-gray-300 hover:text-primary uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              SOLUÇÃO
            </button>
            <button
              onClick={() => scrollToSection('planos')}
              className="text-gray-300 hover:text-primary uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              PLANOS
            </button>
            <Link
              to="/casos-de-sucesso"
              className="text-gray-300 hover:text-primary uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              CASOS DE SUCESSO
            </Link>
            <Link
              to="/blog"
              className="text-gray-300 hover:text-primary uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              BLOG
            </Link>
            <button
              onClick={() => scrollToSection('garantia')}
              className="text-gray-300 hover:text-primary uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              GARANTIA
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-gray-300 hover:text-primary uppercase text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              CONTATO
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            mobileMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="flex flex-col space-y-1 pb-4 bg-dark-secondary/50 rounded-xl p-2">
            <button
              onClick={() => scrollToSection('solucao')}
              className="text-gray-300 hover:text-primary hover:bg-dark-tertiary uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              SOLUÇÃO
            </button>
            <button
              onClick={() => scrollToSection('planos')}
              className="text-gray-300 hover:text-primary hover:bg-dark-tertiary uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              PLANOS
            </button>
            <Link
              to="/casos-de-sucesso"
              onClick={() => setMobileMenuOpen(false)}
              className="text-gray-300 hover:text-primary hover:bg-dark-tertiary uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              CASOS DE SUCESSO
            </Link>
            <Link
              to="/blog"
              onClick={() => setMobileMenuOpen(false)}
              className="text-gray-300 hover:text-primary hover:bg-dark-tertiary uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              BLOG
            </Link>
            <button
              onClick={() => scrollToSection('garantia')}
              className="text-gray-300 hover:text-primary hover:bg-dark-tertiary uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              GARANTIA
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-gray-300 hover:text-primary hover:bg-dark-tertiary uppercase text-sm font-medium transition-colors cursor-pointer py-3 px-4 rounded-lg text-left"
            >
              CONTATO
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
